// extracted by mini-css-extract-plugin
export default {"burger":"HcGHdNjQWlfWA5ua4h6d"};